import { render, staticRenderFns } from "./checkCategoriaParametri.vue?vue&type=template&id=21638273&"
import script from "./checkCategoriaParametri.vue.ts?vue&type=script&lang=ts&"
export * from "./checkCategoriaParametri.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports